<template>
  <div>
    <div class="my-3">

      <b-row class="d-flex align-items-center">
        <b-form-checkbox
          class="col-2 ml-1"
          switch 
          v-model="drogas.active"
        >
          Drogas
        </b-form-checkbox>

        <v-select
          v-if="drogas.active"
          class="col"
          placeholder="Seleccione los tipos de drogas"
          :options="drogasOpts"
          :reduce="option => option"
          label="text"
          :multiple="true"
          taggable
          @input="newArray => drogas.selected = onAddNewOpt(newArray)"
        />
      </b-row>

    </div>

    <hr class="my-2"/>

    <div>
      <b-row class="my-3 d-flex align-items-center">
        <h5 class="col-2">Vacunas</h5> 
        <v-select
          class="col"
          placeholder="Seleccione una o mas opciones"
          :options="vacunasOpts"
          :reduce="option => option"
          label="text"
          :multiple="true"
          taggable
          @input="newArray => vacunas.selected = onAddNewOpt(newArray)"
        />

      </b-row>

      <b-card
        border-variant="light" 
        v-if="vacunas.selected.some(opt => opt.value ==='covid_19')" 
      >

        <b-row class="my-1">

          <b-col class="col-3 d-flex">
            <label for="" >Tuvo Covid:</label>
            <b-form-checkbox
              class="ml-1"
              switch 
              v-model="vacunas.covid.active" 
            />
          </b-col>

          <b-col v-if="vacunas.covid.active">
            <b-row >
              
              <label class="col-3">Nivel de gravedad:</label>

              <b-input-group 
                class="col"
                :append="vacunas.covid.gravedad"
              >
                <b-form-input
                  type="range"
                  min=0
                  max=120
                  v-model="vacunas.covid.gravedad"
                />
              </b-input-group>
                
            </b-row>
          </b-col>
        </b-row>
        
      </b-card>
    </div>

    <hr>

    <div class="my-3">
      <b-row>
        <h5 class="col-2">Sintomas</h5>

        <v-select
          class="col"
          placeholder="Seleccione una o mas opciones"
          :options="sintomasOpts"
          :reduce="option => option"
          label="text"
          :multiple="true"
          taggable
          @input="newArray => sintomas.selected = onAddNewOpt(newArray)"
        />
      </b-row>
    </div>

  </div>
</template>

<script>

import vSelect from "vue-select";
import { addNewOpt } from '@/shared/helpers';

export default {
  name: "DrogasVacunasSintomas",

  components: {
    vSelect
  },

  data() {
    return {
      drogas: {
        active: false,
        selected: [],
      },

      drogasOpts:[
        { value: 'estimulantes',  text: 'Estimulantes' },
        { value: 'alucinogenos',  text: 'Alucinogenos' },
        { value: 'cannabinoides', text: 'Cannabinoides' },
        { value: 'inhalantes',    text: 'Inhalantes' },
      ],

      vacunas: {
        selected: [],
        covid:{
          active: false,
          gravedad:"0"
        },
      },

      vacunasOpts: [
        { value: "bcg",             text: "BCG" },
        { value: "hepatitis_b",     text: "Hepatitis B" },
        { value: "influenza",       text: "Influenza" },
        { value: "dtp",             text: "Dpt" },
        { value: "pentavalente",    text: "Pentavalente" },
        { value: "varicela",        text: "Varicela" },
        { value: "vph",             text: "VPH" },
        { value: "rotavirus",       text: "Rotavirus" },
        { value: "fiebre_amarilla", text : "Fiebre Amarilla" },
        { value: "neumococo",       text: "Neumococo" },
        { value: "polio",           text: "Polio" },
        { value: "covid_19",        text: "Covid 19" },
      ],

      sintomas: {
        selected: [],
      },

      sintomasOpts : [
        { value: "tos_seca",                     text: "Tos seca" },
        { value: "tos_humeda",                   text: "Tos húmeda" },
        { value: "tos_intermitente",             text: "Tos intermitente/persistente/matutina/nocturna" },
        { value: "hemoptisis",                   text: "Hemoptisis" },
        { value: "epistaxis",                    text: "Epistaxis" },
        { value: "expectoracion",                text: "Expectoración" },
        { value: "dolor_toracico",               text: "Dolor torácico" },
        { value: "dolor_de_garganta",            text: "Dolor de garganta" },
        { value: "falta_de_aire",                text: "Falta de aire" },
        { value: "obstruccion_nasal",            text: "Obstrucción nasal" },
        { value: "rinorrea",                     text: "Rinorrea" },
        { value: "estornudos",                   text: "Estornudos" },
        { value: "fiebre",                       text: "Fiebre" },
        { value: "sudoraciones",                 text: "Sudoraciones" },
        { value: "perdida_de_peso",              text: "Pérdida de peso" },
        { value: "ronquidos_nocturnos",          text: "Ronquidos nocturnos" },
        { value: "hallazgo_radiologico_anormal", text: "Hallazgo radiológico anormal" }
      ]

    }
  },


  methods: {

    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },
    
  },

  watch:{

    drogas: {
      deep: true,
      handler(newValue) {
        this.$store.commit("setNeumologica", { drogas:newValue } );
      }
    },

    vacunas: {
      deep: true,
      handler(newValue) {
        this.$store.commit("setNeumologica", { vacunas:newValue } );
      }
    },

    sintomas:{
      deep: true,
      handler(newValue) {
        this.$store.commit("setNeumologica", { sintomas:newValue } );
      }
    },
  }

}
</script>
